// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// material-ui icons
import CreditCard from "@material-ui/icons/CreditCard";
import Subtitles from "@material-ui/icons/Subtitles";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Event from "@material-ui/icons/Event";
import Grade from "@material-ui/icons/Grade";

// material-ui components
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import NavPills from "beaktShared/components/NavPills/NavPills.js";
import Clearfix from 'beaktShared/components/Clearfix/Clearfix';
import PagamentoCartao from "beaktClinic/views/Venda/Pagamentos/PagamentoCartao"
import PagamentoDinheiro from "beaktClinic/views/Venda/Pagamentos/PagamentoDinheiro"
import PagamentoCheque from "beaktClinic/views/Venda/Pagamentos/PagamentoCheque"
import PagamentoBoleto from "beaktClinic/views/Venda/Pagamentos/PagamentoBoleto"
import PagamentoOutros from "beaktClinic/views/Venda/Pagamentos/PagamentoOutros"
import QrCodeBeaktPix from "beaktClinic/views/Venda/Pagamentos/QRCodeBeaktPix";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { setcarrinhoVendaCookie, getcarrinhoVendaCookie, setResultadoVendaCookie } from "beaktClinic/services/carrinhoVenda";
import { MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1 } from "beaktShared/helpers/masks";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoVenda.js";
import styles2 from "assets/jss/BeaktClinic/views/Venda/finalizacaoVenda.js";

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function PagamentoVendaEfetuada({ venda, CallbackVendasEmAndamento }) {

  const { t } = useTranslation();
  const classes = useStyles();
  const classes2 = useStyles2();

  const session = useContext(SessionContext);
  const { register, errors } = useForm({ mode: "onBlur" });

  const [messageReturn, setmessageReturn] = React.useState({
    show: false,
    message: ''
  });

  const [visible_ExcluirVenda, set_visible_ExcluirVenda] = React.useState(false);
  const [listaFormasPagamento, setlistaFormasPagamento] = React.useState([]);
  const [tabsPagamento, settabsPagamento] = React.useState([]);
  const [vendaQRCode, set_vendaQRCode] = React.useState(null);

  const [alert, setalert] = React.useState();

  const showAlert = (title, message, tipo) => {
    setalert(<SweetAlert
      warning={tipo == 'warning' ? true : false}
      success={tipo == 'success' ? true : false}
      title={title}
      onConfirm={() => (tipo === "success" ? CallbackVendasEmAndamento() : hideAlert())}
    >
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </SweetAlert>);
  };

  const [pgto, setpgto] = React.useState({
    pagamentos: [],
    totalizadorPagamentos: {
      valorTotalPago: 0,
      valorPendente: 0,
    }
  });
  const setTotalizadorPgtos = () => {
    let lista_pagamentos = [];
    for (var i in venda.venda.vendaGestaoPagamentos) {
      lista_pagamentos.push({
        id: i,
        vendaPagamentoId: venda.venda.vendaGestaoPagamentos[i].id,
        tipo: venda.venda.vendaGestaoPagamentos[i].tipo,
        valor: venda.venda.vendaGestaoPagamentos[i].valor,
        descTipo: venda.venda.vendaGestaoPagamentos[i].descricaoTipo + ": " + venda.venda.vendaGestaoPagamentos[i].descricao,
        parcela: venda.venda.vendaGestaoPagamentos[i].parcela,
        descPacela: venda.venda.vendaGestaoPagamentos[i].parcela + " x",
        bloqueado: (venda.venda.vendaGestaoPagamentos[i].tipo === 1 ? true : false),
        gateway: venda.venda.vendaGestaoPagamentos[i].gateway,
        descricaoFormaPgto: venda.venda.vendaGestaoPagamentos[i].descricao
      });
    }

    let valorPago = 0;
    lista_pagamentos.map(item => {
      valorPago = valorPago + item.valor;
    });

    let vendapagamento = {
      pagamentos: lista_pagamentos,
      totalizadorPagamentos: {
        valorTotalPago: valorPago,
        valorPendente: venda.venda.totalVenda - valorPago,
      }
    }
    setpgto(vendapagamento);
  }

  const permiteExcluirVenda = () => {

    UseGetApiSimple("vendas/permiteExcluirVenda/" + venda.venda.vendaId).then(result => {

      if (result.data == true) {
        set_visible_ExcluirVenda(true);
      }
      else
        set_visible_ExcluirVenda(false);
    });

  }

  useEffect(() => {
    setloadComplete(true);
    loadFormasPagamento();
    permiteExcluirVenda();
  }, []);

  useEffect(() => {
    setmessageFinalizaReturn({ show: false })
    loadTabsFormasPagamento();
  }, [pgto]);

  const loadTotalizadorPgtos = (pgto) => {
    let valorPago = 0;
    pgto.pagamentos.map(item => {
      valorPago = valorPago + item.valor;
    });

    let valorSaldoPendente = venda.venda.totalVenda - valorPago;
    valorSaldoPendente = (valorSaldoPendente).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    valorSaldoPendente = transformValueFormatedtoFloat(valorSaldoPendente);

    let updatepgto = {
      ...pgto,
      totalizadorPagamentos: {
        valorTotalPago: valorPago,
        valorPendente: valorSaldoPendente,
      }
    };

    setpgto(updatepgto);
    return updatepgto;
  }

  const handleRemovePg = (item) => {

    let listFiltered = pgto.pagamentos.filter(obj => {
      return obj.id !== item.id;
    });

    let updatepgto = {
      ...pgto,
      pagamentos: listFiltered
    }

    loadTotalizadorPgtos(updatepgto);
  }

  const loadFormasPagamento = () => {
    UseGetApiSimple("formaPagamentos/ativos/byestabelecimento/" + session.estabelecimentoId).then(result => {
      setloadComplete(false);
      if (result.status !== 200) {
        setmessageReturn({
          show: true,
          message: 'Não foi possível carregar as formas de pagamento!'
        });
        return false;
      }
      setlistaFormasPagamento(result.data);
      setTotalizadorPgtos();
    });
  }

  const loadTabsFormasPagamento = () => {
    let tabs = [];
    if (listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 1).length > 0) {
      tabs.push({
        tabButton: "Cartão",
        tabIcon: CreditCard,
        tabContent: (
          <div>
            <PagamentoCartao CallloadTotalizadorPgtosCt={loadTotalizadorPgtos} pgto={pgto} formasCartao={listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 1)}></PagamentoCartao>
          </div>
        )
      });
    }
    if (listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 0).length > 0) {
      tabs.push({
        tabButton: "Dinheiro",
        tabIcon: AttachMoney,
        tabContent: (
          <div>
            <PagamentoDinheiro CallloadTotalizadorPgtos={loadTotalizadorPgtos} pgto={pgto}></PagamentoDinheiro>
          </div>
        )
      });
    }
    if (listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 2).length > 0) {
      tabs.push({
        tabButton: "Boleto",
        tabIcon: Event,
        tabContent: (
          <div>
            <PagamentoBoleto CallloadTotalizadorPgtosBo={loadTotalizadorPgtos} pgto={pgto}></PagamentoBoleto>
          </div>
        )
      });
    }
    if (listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 3).length > 0) {
      tabs.push({
        tabButton: "Cheque",
        tabIcon: Subtitles,
        tabContent: (
          <div>
            <PagamentoCheque CallloadTotalizadorPgtosCq={loadTotalizadorPgtos} pgto={pgto}></PagamentoCheque>
          </div>
        )
      });
    }
    if (listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 4).length > 0) {
      tabs.push({
        tabButton: "Outros",
        tabIcon: Grade,
        tabContent: (
          <div>
            <PagamentoOutros CallloadTotalizadorPgtosOutros={loadTotalizadorPgtos} pgto={pgto} formaOutros={listaFormasPagamento.filter(({ tipoFormaPagamento }) => tipoFormaPagamento === 4)}></PagamentoOutros>
          </div>
        )
      });
    }
    settabsPagamento(tabs);
  }

  const [messageFinalizaReturn, setmessageFinalizaReturn] = React.useState({
    show: false,
    message: ''
  });

  const [loadComplete, setloadComplete] = React.useState(true);
  const handleFinalizaVenda = () => {
    if (pgto.totalizadorPagamentos.valorPendente !== 0) {
      setmessageFinalizaReturn({
        show: true,
        message: 'O valor de Saldo a Pagar deverá ser zerado!'
      });
      return false;
    }

    setloadComplete(true);
    let endPoint = "vendas/pagamentovenda/" + venda.venda.vendaId;
    UsePostApi(endPoint, pgto.pagamentos).then(result => {
      console.log(result);
      if (result.status !== 200) {
        showAlert("Aviso", result.message.message, 'warning');
        setloadComplete(false);
        return false;
      }

      if (result.data.status == 6)
        showAlert(result.data.mensagem, result.data.mensagem_beakt, 'warning');
      else if (result.data.status === 2 && result.data.qrCodeBeaktPix)
        set_vendaQRCode(result.data);
      else
        showAlert(result.data.mensagem, result.data.mensagem_beakt, 'success');

      setloadComplete(false);
      return true;
    });
  }

  const hideAlert = () => {
    setalert(null);
  };

  const handleExcluirVenda = () => {
    if (pgto.totalizadorPagamentos.valorTotalPago > 0) {
      setmessageReturn({
        show: true,
        message: 'Não foi possível carregar as formas de pagamento!'
      });
      return false;
    }

    let data = {
      usuarioCancelamentoId: session.id,
      vendaId: venda.venda.vendaId,
      oBS: t('information_message.contract_deleted_by_clinic')
    }

    const endPoint = "vendas/CancelarContrato";
    UsePostApi(endPoint, data).then(result => {
      if (result.status !== 200) {
        setmessageReturn({
          show: true,
          message: 'Não foi possível carregar as formas de pagamento!'
        });
      }
    });

    setcarrinhoVendaCookie(null);
    CallbackVendasEmAndamento();
    return true;
  }

  const statusPagamentoVenda = (vendaId) => {
    setloadComplete(true);
    let endPoint = "vendas/StatusPagamento/" + vendaId;
    UsePostApi(endPoint, null).then(result => {
      setloadComplete(false);
      if (result.status !== 200) {
        showAlert(result.data.mensagem, result.data.mensagem_beakt, 'warning');
        return false;
      }

      if (result.data.status === 4) {
        set_vendaQRCode(null);
        showAlert(result.data.mensagem, result.data.mensagem_beakt, 'success');
      }
      else
        showAlert(result.data.mensagem, result.data.mensagem_beakt, 'warning');
    });
  }


  return (
    <div className="maxContent">

      {loadComplete &&
        <div className="carregandoCmp">
          <div className="box">
            <label>Carregando...</label>
            <CircularProgress />
          </div>
        </div>
      }

      {alert}

      <GridContainer>

        <GridItem xs={12} sm={8} md={8}>
          <Card>
            <CardBody>

              <h3>Formas de Pagamento</h3>

              <div style={{ maxWidth: '700px', margin: '0 auto' }}>
                <NavPills
                  color="primary"
                  alignCenter
                  tabs={tabsPagamento}
                />
              </div>
              {messageReturn.show &&
                <div><div className="alertErrorEx alertmax">
                  <p>
                    {messageReturn.message}
                  </p>
                </div><br /></div>
              }
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4}>
          <Card>
            <CardBody>

              <h4>Pagamentos Realizados</h4>

              {pgto.pagamentos.map(item => (
                <div key={item.id}>
                  <div className={classes.boxItemPg}>
                    <div className={classes.descForma}>
                      {item.descTipo}
                    </div>
                    <div className={classes.valuePg}>
                      <small>R$</small> {transformValueFloattoFormated(item.valor)} <small> ({item.descPacela})</small>
                    </div>
                    <div className={classes.rmvPg}>
                      {item.bloqueado != true &&
                        <a href="#" onClick={() => handleRemovePg(item)}>
                          Remover
                        </a>
                      }
                    </div>
                  </div>
                  <br />
                </div>
              ))}

              <br />
              <div className={classes.boxTotalizador}>
                Total da Venda
                <div className={classes.valueTotalizador}>
                  R$ {transformValueFloattoFormated(venda.venda.totalVenda)}
                </div>
                <Clearfix />
              </div>
              <div className={classes.boxTotalizador}>
                Total de Pagamentos
                <div className={classes.valueTotalizador}>
                  R$ {transformValueFloattoFormated(pgto.totalizadorPagamentos.valorTotalPago)}
                </div>
                <Clearfix />
              </div>
              <div className={classes.boxPendencia}>
                Saldo a Pagar
                <div className={classes.valuePendencia}>
                  R$ {transformValueFloattoFormated(pgto.totalizadorPagamentos.valorPendente)}
                </div>
              </div>


              <GridItem xs={12} sm={12} md={12}>
                <br />

                {messageFinalizaReturn.show &&
                  <div><div className="alertErrorEx alertmax">
                    <p>
                      {messageFinalizaReturn.message}
                    </p>
                  </div><br />
                  </div>
                }

                <div className={classes.tCenter}>

                  <Button fullWidth
                    onClick={() => CallbackVendasEmAndamento()}>
                    Voltar
                  </Button>

                  {visible_ExcluirVenda &&
                    <Button fullWidth
                      onClick={() => handleExcluirVenda()}>
                      {t('sale.delete_sale')}
                    </Button>
                  }

                  <Link to="/adminclinic/finalizacaovenda" >
                  </Link>
                  <Button fullWidth color="info"
                    onClick={() => handleFinalizaVenda()} >
                    Finalizar Pagamento
                  </Button>

                </div>
              </GridItem>

            </CardBody>
          </Card>
        </GridItem>

      </GridContainer>

      {vendaQRCode &&
        <QrCodeBeaktPix qrCodeBeaktPix_value={vendaQRCode.qrCodeBeaktPix} showModal={true} closeModal={() => set_vendaQRCode(null)} atualizarStatus={() => statusPagamentoVenda(vendaQRCode.vendaId)}></QrCodeBeaktPix>
      }
    </div>
  );
}